import React from 'react'

import {
  formatKubernetesParams,
  generateKubernetesSelectionOptions,
  type TargetsByOwner
} from 'components/attacks/create/targets/kubernetes/kubernetes-target-utils'

import type { K8sObject } from 'types/api/kubernetes/kubernetes'

export type FormattedK8sTargetingData<T extends K8sObject = K8sObject> = {
  labelKeys: Record<string, TargetsByOwner<T>[]>
  availableTargetParams: Set<string>
  targetsByOwners: TargetsByOwner<T>[]
}

// Reusable code to format k8s data for attack targeting
export function useGetFormattedK8sTargetingData<
  T extends K8sObject = K8sObject
>(targets: T[]): FormattedK8sTargetingData<T> {
  return React.useMemo(() => {
    const targetsByOwners = generateKubernetesSelectionOptions<T>(targets)
    const { labelKeys, availableTargetParams } =
      formatKubernetesParams<T>(targetsByOwners)

    return {
      labelKeys,
      availableTargetParams,
      targetsByOwners
    }
  }, [targets])
}
